import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

export const FAQSection = () => {
  return (
    <section id="faqs" className="py-20 bg-[#EFEBE9]">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-[#8D6E63]">
            Get answers to common questions about trademark registration
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white border-2 border-[#D7CCC8] rounded-lg px-6 hover:border-[#8D6E63] transition-colors duration-300"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-[#3E2723] hover:text-[#8D6E63] py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#8D6E63] leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
